import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {UnauthorizedComponent} from './modules/shared/components/unauthorized/unauthorized.component';
import { SharedModule } from './modules/shared/shared.module';
import { NotificationsComponent } from './modules/shared/components/notifications/notifications.component';

const routes: Routes = [
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
  { path: 'auth', loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule) },
  { path: 'user', loadChildren: () => import('./modules/user/user.module').then(m => m.UserModule) },
  { path: 'periods', loadChildren: () => import('./modules/periods/periods.module').then(m => m.PeriodsModule) },
  {path: 'concepts', loadChildren: () => import('./modules/concepts/concepts.module').then(m => m.ConceptsModule)},
  {path: 'expense-reports', loadChildren: () => import('./modules/expense-reports/expense-reports.module').then(m => m.ExpenseReportsModule)},
  {path:'employee-discounts',loadChildren:()=> import('./modules/employee-discounts/employee-discounts.module').then(m=>m.EmployeeDiscountsModule)},
  {path:'ecclesiastic-data',loadChildren:()=> import('./modules/ecclesiastic-data/ecclesiastic-data.module').then(m=>m.EcclesiasticDataModule)},
  {path:'system-config',loadChildren:()=> import('./modules/system-config/system-config.module').then(m=>m.SystemConfigModule)},
  {path:'notifications',component:NotificationsComponent}, 
  {path:'unauthorized',component:UnauthorizedComponent},
  { path: '**', redirectTo: 'auth/login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
